export { type BinaryTarget, binaryTargets } from './binaryTargets'
export type { PlatformInfo } from './getPlatform'
export { getBinaryTargetForCurrentPlatform, getos, getPlatformInfo } from './getPlatform'
export { link } from './link'
export * from './test-utils'
